import * as types from './types'
import { CIVIL_LOW_TYPES } from './constants'

const modalData = {
	item: null,
	child: null,
	type: Object.fromEntries(
		Object.values(CIVIL_LOW_TYPES).map(key => [key, false]),
	),
}

const data = {
	loading: false,
	success: false,
	failed: false,
	data: null,
}

const initialState = {
	modalData: modalData,

	xml: data,
	contracts: data,
	contract: data,
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.SET_MODAL_DATA:
			return {
				...state,
				modalData: {
					...state.modalData,
					item: payload.item || null,
					child: payload.child || null,
					type: { ...state.modalData.type, ...payload.type },
				},
			}

		case types.GET_XML:
		case types.SEND_CONTRACT:
		case types.SEND_SUB_CONTRACT:
		case types.SEND_SUB_GET_XML:
		case types.SEND_DEL_GET_XML:
		case types.SEND_SUB_DEL_GET_XML:
		case types.SEND_TERM_GET_XML:
		case types.SEND_TERM:
			return { ...state, xml: { ...data, loading: true } }

		case types.GET_XML_DONE:
		case types.SEND_CONTRACT_DONE:
		case types.SEND_SUB_CONTRACT_DONE:
		case types.SEND_SUB_GET_XML_DONE:
		case types.SEND_DEL_GET_XML_DONE:
		case types.SEND_SUB_DEL_GET_XML_DONE:
		case types.SEND_TERM_GET_XML_DONE:
		case types.SEND_TERM_DONE:
			return { ...state, xml: { ...data, data: payload, success: true } }

		case types.GET_XML_FAIL:
		case types.SEND_CONTRACT_FAIL:
		case types.SEND_SUB_CONTRACT_FAIL:
		case types.SEND_SUB_GET_XML_FAIL:
		case types.SEND_DEL_GET_XML_FAIL:
		case types.SEND_SUB_DEL_GET_XML_FAIL:
		case types.SEND_TERM_GET_XML_FAIL:
		case types.SEND_TERM_FAIL:
			return { ...state, xml: { ...data, failed: true } }


		case types.GET_CONTRACTS:
			return { ...state, contracts: { ...data, loading: true } }

		case types.GET_CONTRACTS_DONE:
			return { ...state, contracts: { ...data, data: payload, success: true } }

		case types.GET_CONTRACTS_FAIL:
			return { ...state, contracts: { ...data, failed: true } }


		case types.GET_CONTRACT:
			return { ...state, contract: { ...data, loading: true } }

		case types.GET_CONTRACT_DONE:
			return { ...state, contract: { ...data, data: payload, success: true }}

		case types.GET_CONTRACT_FAIL:
			return { ...state, contract: { ...data, failed: true } }


		default:
			return state
	}
}
